var map = {
	"./bitdeer.png": "51e9",
	"./btccom.png": "7755",
	"./genesis_mining.png": "e109",
	"./hashnest.png": "3c5a",
	"./iqmining.png": "4830",
	"./miningzoo.png": "172e",
	"./nicehash.png": "e549",
	"./oxbtc.png": "ae2e",
	"./veryhash.png": "f603",
	"./viabtc.png": "7829",
	"./wayi.png": "4177"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5131";